import {
    DlRenewalEligibilityCheckRequest,
    DlRenewalEligibilityCheckResponse,
    EmailReceiptsResponse,
    FinalizeTransactionRequest,
    HcRenewalEligibilityCheckRequest,
    HcRenewalEligibilityCheckResponse,
    OpcRenewalEligibilityCheckRequest,
    OpcRenewalEligibilityCheckResponse,
    ReceiptsRequest,
    ReceiptsResponse,
    RenewDriverLicenseRequest,
    RenewDriverLicenseResponse,
    RenewHealthCardHeaders,
    RenewHealthCardRequest,
    RenewHealthCardResponse,
    RenewPhotoCardRequest,
    RenewPhotoCardResponse,
} from '~/models/product-renewal';
import { api } from '~/services/api.service';
import { unFormat } from '~/utils/helpers';

const checkEligibilityForDL = async (request: DlRenewalEligibilityCheckRequest) => {
    return api.post<DlRenewalEligibilityCheckResponse>(
        'PRODUCT_RENEWAL',
        `${process.env.CXP_API_PRODUCT_RENEWAL_DL_ELIGIBILITY_ENDPOINT}`,
        {
            ...request,
            driverLicenseEligibility: unFormat(request.driverLicenseEligibility),
        }
    );
};

const checkEligibilityForOPC = async (request: OpcRenewalEligibilityCheckRequest) => {
    return api.post<OpcRenewalEligibilityCheckResponse>(
        'PRODUCT_RENEWAL',
        `${process.env.CXP_API_PRODUCT_RENEWAL_OPC_ELIGIBILITY_ENDPOINT}`,
        {
            ...request,
            photoCard: unFormat(request?.photoCard),
        }
    );
};

const checkEligibilityForHC = async (request: HcRenewalEligibilityCheckRequest) => {
    return api.post<HcRenewalEligibilityCheckResponse>(
        'PRODUCT_RENEWAL',
        `${process.env.CXP_API_PRODUCT_RENEWAL_HC_ELIGIBILITY_ENDPOINT}`,
        {
            ...request,
            healthCard: unFormat(request.healthCard),
        }
    );
};

const renewDriversLicense = async (
    payload: RenewDriverLicenseRequest,
    mtoToken: string,
    transactionId: string
) => {
    return api.post<RenewDriverLicenseResponse>(
        'PRODUCT_RENEWAL',
        `${process.env.CXP_API_PRODUCT_RENEWAL_DL_ENDPOINT}`,
        {
            ...(unFormat(payload) as unknown as RenewDriverLicenseResponse),
        },
        {
            mtoToken,
            transactionId,
        },
        {
            params: {
                languageCode: payload.languageCode,
            },
        }
    );
};

const renewPhotoCard = async (payload: RenewPhotoCardRequest, transactionId: string) => {
    return api.post<RenewPhotoCardResponse>(
        'PRODUCT_RENEWAL',
        `${process.env.CXP_API_PRODUCT_RENEWAL_OPC_ENDPOINT}`,
        {
            ...payload,
            item: unFormat(payload?.item),
        },
        {
            transactionId,
        },
        {
            params: {
                languageCode: payload.languageCode,
            },
        }
    );
};

const renewHealthCard = async (
    payload: RenewHealthCardRequest,
    headers: RenewHealthCardHeaders
) => {
    return api.post<RenewHealthCardResponse>(
        'PRODUCT_RENEWAL',
        `${process.env.CXP_API_PRODUCT_RENEWAL_HC_ENDPOINT}`,
        unFormat(payload),
        headers
    );
};

const finalizeTransaction = async (payload: FinalizeTransactionRequest) => {
    return api.post<RenewHealthCardResponse>(
        'PRODUCT_RENEWAL',
        `${process.env.CXP_API_PRODUCT_RENEWAL_FINALIZE_TRANSACTION_ENDPOINT}`,
        payload
    );
};

const emailReceipts = async (payload: ReceiptsRequest) => {
    return api.post<EmailReceiptsResponse>(
        'PRODUCT_RENEWAL',
        `${process.env.CXP_API_PRODUCT_RENEWAL_EMAIL_RECEIPTS_ENDPOINT}`,
        payload
    );
};

const downloadReceipts = async (payload: ReceiptsRequest) => {
    return api.post<ReceiptsResponse>(
        'PRODUCT_RENEWAL',
        `${process.env.CXP_API_PRODUCT_RENEWAL_RECEIPTS_ENDPOINT}`,
        payload
    );
};

export default {
    checkEligibilityForDL,
    checkEligibilityForOPC,
    checkEligibilityForHC,
    renewDriversLicense,
    renewHealthCard,
    renewPhotoCard,
    finalizeTransaction,
    emailReceipts,
    downloadReceipts,
};
